if ($(window).width() < 767) {
} else {
  $('.site-nav--has-dropdown')
    .on('mouseover', function () {
      $('.custom-header-height:not(.stop-hover) .header-row').removeClass('header_transparent');
      $('.custom-header-height:not(.stop-hover) .header-row').addClass('header_black');
    })
    .mouseout(function () {
      $('.custom-header-height:not(.stop-hover) .header-row').removeClass('header_black');
      $('.custom-header-height:not(.stop-hover) .header-row').addClass('header_transparent');
    });
}

// Mobile menu click
$('.mo_menulink').on('click', function () {
  $('.header-row').toggleClass('header_transparent');
});

if ($(window).width() < 767) {
  function updateProgressBar() {
    const progressBar = document.querySelector('.hs-progress-bar');
    progressBar.style.width = progressBarWidth + '%';
  }
  jQuery('.product-swiper').each(function (index, value) {
    const swiperClass = 'swiper' + index;
    jQuery(this).addClass(swiperClass);
    const previousNavClass = 'swiper-button-prev' + index;
    const nextNavClass = 'swiper-button-next' + index;
    const scrollBarClass = 'swiper-scrollbar' + index;
    const scrollbar = `<div class="swiper-scrollbar ${scrollBarClass}"></div>`;
    jQuery(this).append(scrollbar);
    jQuery(this).parent().find('.swiper-button-prev').addClass(previousNavClass);
    jQuery(this).parent().find('.swiper-button-next').addClass(nextNavClass);
    jQuery(this).parent().find('.swiper-scrollbar').addClass(scrollBarClass);
    var swiper = new Swiper(`.${swiperClass}`, {
      slidesPerView: 1.5,
      spaceBetween: 25,
      grabCursor: true,
      /*autoHeight: true,*/
      navigation: {
        nextEl: `.${nextNavClass}`,
        prevEl: `.${previousNavClass}`,
      },
      scrollbar: {
        el: `.${scrollBarClass}`,
        draggable: true,
      },
      breakpoints: {
        640: {
          slidesPerView: 1.5,
          spaceBetween: 25,
        },
        768: {
          slidesPerView: 4,
          spaceBetween: 32,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 32,
        },
      },
    });
  });

  function updateProgressBars() {
    const progressBars = document.querySelector('.hs-progress-bar');
    progressBars.style.width = progressBarWidth + '%';
  }
  jQuery('.product-swiper2').each(function (index, value) {
    const swiperClasss = 'swiper' + index;
    jQuery(this).addClass(swiperClasss);
    const previousNavClasss = 'swiper-button-prev' + index;
    const nextNavClasss = 'swiper-button-next' + index;
    const scrollBarClasss = 'swiper-scrollbar' + index;
    const scrollbars = `<div class="swiper-scrollbar ${scrollBarClasss}"></div>`;
    jQuery(this).append(scrollbars);
    jQuery(this).parent().find('.swiper-button-prev').addClass(previousNavClasss);
    jQuery(this).parent().find('.swiper-button-next').addClass(nextNavClasss);
    jQuery(this).parent().find('.swiper-scrollbar').addClass(scrollBarClasss);
    var swiper = new Swiper(`.${swiperClasss}`, {
      slidesPerView: 1.5,
      spaceBetween: 25,
      grabCursor: true,
      /*autoHeight: true,*/
      navigation: {
        nextEl: `.${nextNavClasss}`,
        prevEl: `.${previousNavClasss}`,
      },
      scrollbar: {
        el: `.${scrollBarClasss}`,
        draggable: true,
      },
      breakpoints: {
        640: {
          slidesPerView: 1.5,
          spaceBetween: 25,
        },
        768: {
          slidesPerView: 4,
          spaceBetween: 32,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 32,
        },
      },
    });
  });
}


